import { Container, Stack, Text, Title } from '@mantine/core';
import { useVenueProfile } from '../profile-context';
import { TakeoutForm } from '../components/TakeoutForm';

/**
 * Standalone takeout route. Mirrors the booking page's compact header so
 * branding stays consistent whether the guest lands on booking or takeout.
 */
export function TakeoutPage(): JSX.Element {
  const profile = useVenueProfile();
  return (
    <Container size="sm" py="xl">
      <Stack gap="md">
        <div>
          <Title order={2}>{profile.branding.appTitle}</Title>
          <Text c="dimmed" size="sm">
            外帶訂購
          </Text>
        </div>
        <TakeoutForm venueId={profile.venueId} />
      </Stack>
    </Container>
  );
}
